<template>
  <div class="register-page">
    <div :class="computedClass">
      <!-- <div class="page-title col-xs-12 col-sm-6 pt-2">
        Registrar / Agendas ({{ list.length }})
      </div> -->
      <div class="col-lg-6 d-flex align-items-center">
        <PageTitle
          :titles="['Cadastrar', 'Agendas']"
          :dataCount="list.length"
        />
      </div>
      <toolbar
        class="col-xs-12 col-sm-6"
        type="schedule"
        :is-mobile="mobile"
        :is-searching="isSearching"
        @search="searchBy"
        @clear-search="clearSearch"
        @edit="edit"
        @remove="remove()"
        @add="add"
        :selected="selected"
        :number-of-elements="list.length"
        :PDF="selected.length == 0 ? list : selected"
        :show-ferti="checked"
        :locality="local"
        :type-filtering="''"
        :not-exists="showErrorNotFound"
        :not-search="showErrorNotSearch"
        ref="INP"
        :is-show="loading"
        :filters="filters"
        :filter-opt="filterOpt"
        @filter-by="onFilterBy"
        @duplicate="duplicateAgn"
      />
    </div>

    <div class="register-main">
      <div class="list-items row">
        <div v-if="loading" class="col-xs-12 center-xs">
          <spinner /> Aguarde...
        </div>
        <div
          v-if="showErrorNotFound"
          class="EmptyRequest w-100 h-100 p-0 row center-xs center-md center-sm center-xs mt-3"
        >
          <img :src="emptyIcon" class="empty" />
          <span>Não há agendas para exibir.</span>
        </div>

        <div
          v-if="showErrorNotSearch && !showErrorNotFound"
          class="EmptyRequest row center-xs mx-2 md-12 w-100 p-0 mt-3"
          style="text-align: left"
        >
          <img :src="searchIcon" class="empty" />
          <span>
            Nenhum resultado encontrado. Para voltar a exibir todas as agendas
            <b-link @click="clearSearch"> clique aqui </b-link> .
          </span>
        </div>
        <div
          v-for="(item, index) in listMappedManagementSuggestion"
          :key="index"
          class="col-xs-12 col-sm-4 col-md-3"
        >
          <div class="item-card schedule-card">
            <div class="header-card">
              <div class="header-title">
                <div
                  class="d-flex justify-content-between w-100 align-items-center"
                >
                  <h5 :title="item.NAME">{{ item.NAME }}</h5>

                  <div
                    class="d-flex justify-content-between align-items-center h-100"
                  >
                    <span
                      v-if="
                        hasManagementBlade(item) &&
                        !expiration(item.END_DATE, item.END_TIME)
                      "
                      class="d-flex align-items-center"
                    >
                      <water-icon
                        v-for="(alertSchedule, index) in item.alerts_management"
                        :key="index"
                        :title="alertSchedule.title"
                        :class="alertSchedule.class"
                      />
                    </span>

                    <code-not-equal-icon
                      v-if="hasManagementBlade(item)"
                      title="Agenda com válvula(s) de setor(es) de manejo"
                      class="text-success"
                    />

                    <alert-circle-icon
                      v-if="multiSectorValves(item).length"
                      :title="`Válvula(s) usada(s) em mais de um setor ativo: ${multiSectorValves(item).join(', ')}`"
                      class="text-danger"
                    />

                    <beaker-icon
                      v-if="item.sublevels.find((level) => level.FERTI.length)"
                      title="Agenda com ferti"
                      class="text-success"
                    />

                    <flash-off-icon
                      v-if="Number(item.PEAK_HOUR_BLOCK)"
                      title="Pausa no horário de ponta"
                      class="text-warning"
                    />
                  </div>
                </div>
                <calendar-remove-icon
                  v-if="expiration(item.END_DATE, item.END_TIME)"
                  class="calendar-icon"
                  title="Agenda expirada"
                />
              </div>

              <span
                v-html="
                  expiration(item.END_DATE, item.END_TIME)
                    ? `<span style='color:#f6783d;'>Expirada</span>`
                    : `<span style='color:#7AB648;'>Válida</span>`
                "
                class="expiration"
              />
            </div>
            <div class="card-details">
              <span
                v-html="formatDays(item.ACTIVITY_DAYS)"
                class="format-days"
              />
              <br />
              <div>
                <strong>Início:</strong>
                {{ formatDateTime(item.START_DATE, item.START_TIME) }}
              </div>
              <div>
                <strong>Expira:</strong>
                {{
                  formatDateTime(item.END_DATE, item.END_TIME) || "Não expira"
                }}
              </div>

              <div class="btn-levels">
                <b-link @click="openLevels(item)">
                  Ver níveis ({{ item.LEVELS ? item.LEVELS : 0 }})
                  <beaker-icon
                    v-if="item.sublevels.filter((e) => !!e.FERTI.length).length"
                    title="Agenda com ferti"
                  />
                </b-link>
              </div>

              <div class="btn-levels">
                <b-link v-if="item.FK_SENSOR" @click="showCond(item)">
                  Ver condição de operação
                </b-link>
              </div>
            </div>

            <div class="footer">
              <!-- @click="duplicateGroup(group.index)" -->

              <b-checkbox
                class="checkbox last-update"
                :id="`checkbox${item.NAME}`"
                :value="item"
                v-model="selected"
              />

              <div>
                <label
                  :for="`checkbox${item.NAME}`"
                  class="details-btn last-update"
                >
                  Editada em {{ item.UPDATE }}
                </label>
                <edited-agn-icon
                  v-if="item.EDITOR_NAME"
                  :alt="`Último editor: ${item.EDITOR_NAME}`"
                  title=""
                  class="action-icon-right details-btn"
                  :id="`editor${item.NAME}`"
                />
              </div>
              <b-tooltip
                :ref="`editor${item.NAME}`"
                :target="`editor${item.NAME}`"
                placement="topleft"
              >
                Último editor: {{ item.EDITOR_NAME }}
              </b-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal ref="condModal" centered size="sm" hide-footer hide-header>
      <h5>{{ cond.NAME }}</h5>
      <strong>Sensor:</strong> {{ cond.SENSOR_NAME }} <br /><strong
        >Medição:</strong
      >
      {{ cond.SENSOR_MEASURE }} ({{ cond.SENSOR_UNIT }}) <br /><strong
        >Ação:</strong
      >
      {{ ["Inversa", "Direta"][cond.ACTION_SENSOR] }} <br /><strong
        >Máximo:</strong
      >
      {{ cond.MAX_SENSOR }} <br /><strong>Mínimo:</strong> {{ cond.MIN_SENSOR }}
    </b-modal>

    <b-modal
      ref="removeSchedule"
      centered
      size="sm"
      ok-title="Deletar"
      ok-variant="danger"
      @ok="confirmRemove"
      cancel-title="Cancelar"
      cancel-variant="outline-secondary"
      title="Atenção!"
    >
      <div class="modal-form">
        <div class="title-modal-info">
          {{
            selected.length == 1
              ? "1 agenda será apagada"
              : `${selected.length} agendas serão apagadas`
          }}.
        </div>
        <ul class="scrollable info-description">
          <li v-for="agn in whatToDelete" :key="agn.ID">
            {{ agn.NAME }}
          </li>
        </ul>
      </div>
    </b-modal>
    <b-modal
      ref="printSchedule"
      centered
      size="sm"
      ok-title="Imprimir"
      ok-variant="3v3"
      @ok="confirmPrint"
      @hidden="resetModal"
      cancel-title="Cancelar"
      cancel-variant="outline-secondary"
      title="Impressão de agenda"
    >
      <div class="modal-form">
        <b-form-checkbox v-model="checked" name="check-button">
          Exibir subníveis de fertirrigação
        </b-form-checkbox>
      </div>
    </b-modal>
    <schedule-form
      :show-form="showForm"
      :form-type="formType"
      :old-name="formType == 'edit' && selected.length ? selected[0].NAME : ''"
      :item-to-edit="selected.length && selected[0]"
      :already-used-names="fullList.map((e) => e.NAME)"
      :sensors="sensors"
      :aux-sensors="auxSensors"
      :days="days"
      :flows="flows"
      :hectare="hectare"
      @submit="submit"
      @close-form="closeForm"
      :duplicate="isDuplicateForm"
    />
    <div v-if="showLevels">
      <div id="overlay" @click="showLevels = false"></div>
      <div id="details">
        <header id="header" class="row">
          <div class="col-xs-12 monit-item bg-3v3">
            <h5>{{ details.NAME }}</h5>
            <h6>Níveis: {{ details.LEVELS }}</h6>
          </div>
        </header>
        <div class="column pt-1 details-area">
          <div class="content">
            <schedule-levels
              v-if="details.sublevels"
              :flows="flows"
              :hectare="hectare"
              :agn-start="details.START_TIME"
              :levels="details.sublevels"
            />
          </div>
        </div>
        <footer id="footer">
          <b-btn size="sm" block @click="showLevels = false"> Fechar </b-btn>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { forgivedDifferenceTimeManagement } from "./constants";
import { avgVolume, getManagementClassificationSchedule } from "./helpers";
import { schedules, sensors } from "@/api";
import { isMobile, organizer } from "@/pages/components/helpers";
import moment from "moment";
import EventBus from "@/pages/components/eventBus";
import { expiration } from "./helpers";
import calcManagement from "@/mixins/calcManagement";
import PageTitle from "@/pages/temps/components/PageTitle.vue";
export default {
  name: "schedule",
  components: {
    PageTitle,
  },
  mixins: [calcManagement],
  created() {
    this.$emit("title-change", "Agenda");
    this.loadSchedules();
    this.loadFlows();
    this.isActive();
  },
  mounted() {
    EventBus.onShowPrintOptions(() => {
      if (!!this.$refs && !!this.$refs.printSchedule) {
        let isFertiSchedule = [];
        //Se selecionar alguma agenda
        if (!!this.selected.length) {
          this.selected.map((schedule) => {
            return schedule.sublevels.map((sublevel) => {
              // console.log(sublevel, !!sublevel.FERTI.length > 0)
              isFertiSchedule.push(!!sublevel.FERTI.length > 0);
              // return !!sublevel.FERTI.length > 0;
            })[0];
          });
          // console.log(isFertiSchedule)
        }
        //Se for para imprimir todas as agendas
        else {
          this.list.map((schedule) => {
            return schedule.sublevels.map((sublevel) => {
              isFertiSchedule.push(!!sublevel.FERTI.length > 0);
              // return !!sublevel.FERTI.length > 0;
            })[0];
          });
        }
        const showModal = isFertiSchedule.some((option) => !!option);
        if (showModal) {
          this.$refs.printSchedule.show();
        } else {
          this.checked = false;
          this.confirmPrint();
        }
      }
    });
  },
  props: {
    local: [String],
    mobile: Boolean,
  },
  data() {
    return {
      forgivedDifferenceTimeManagement,
      isDuplicateForm: false,
      showLevels: false,
      showForm: false,
      showErrorNotFound: false,
      showErrorNotSearch: false,
      emptyIcon: require("../../../assets/icons/Empty.svg"),
      searchIcon: require("../../../assets/icons/search.svg"),
      //view
      loading: true,
      list: [],
      fullList: [],
      isSearching: false,
      filter: "",
      selected: [],
      allSelected: false,
      details: {
        NAME: "",
        sublevels: [],
      },
      sensors: [],
      auxSensors: [],
      cond: {
        SENSOR_NAME: "",
        SENSOR_MEASURE: "",
        SENSOR_UNIT: "",
        FK_SENSOR: null,
        POS_SENSOR: null,
        ACTION_SENSOR: null,
        MAX_SENSOR: null,
        MIN_SENSOR: null,
      },
      days: [
        { text: "D", value: 1 },
        { text: "S", value: 2 },
        { text: "T", value: 4 },
        { text: "Q", value: 8 },
        { text: "Q", value: 16 },
        { text: "S", value: 32 },
        { text: "S", value: 64 },
      ],
      //edição ou adição de agenda
      formType: "",
      //edição ou adição de níveis de agenda
      isFerti: false,
      levelForm: {
        TIME: 0,
        VOLUME: 0,
        MIN_TIME: 0,
        ADVANCE_TIME: 0,
      },
      hectare: 10000,
      flows: {},
      hasFerti: false,
      selValves: [],
      filters: [{ text: "Expiradas", value: 1 }],
      filterOpt: "",
      isFiltering: false,
      filterBy: 100,
      type: null,
      //Subníveis ferti
      checked: true,
      showFertiLevel: false,
    };
  },
  watch: {
    selected() {
      this.allSelected =
        this.selected.length && this.selected.length == this.list.length;
    },
    isFiltering(newV, oldV) {
      this.isActive();
    },
  },
  computed: {
    listMappedManagementSuggestion() {
      return this.list.map((schedule) => {
        schedule.management_infos = schedule.sublevels
          .map((sublevel) => {
            const minPerVol =
              this.avgVolume(sublevel, this.flows) / sublevel.duration.TIME;

            sublevel.ELEMENTS.map((el) => {
              el.MIN_PER_VOL = minPerVol;

              return el;
            });

            return sublevel.ELEMENTS;
          })
          .map((element) => {
            const {
              NAME,
              BLADE_SUGGESTION,
              AREA,
              TRANSMISSIVITY,
              ALL_AGN_DURATION,
              MIN_PER_VOL,
              SECTORS,
            } = (element && element[0]) || {};

            if (!BLADE_SUGGESTION && BLADE_SUGGESTION !== 0) {
              return;
            }

            const VOLUME_SUGGESTED = this.lam2vol(
              BLADE_SUGGESTION,
              AREA,
              TRANSMISSIVITY
            );
            const TIME_SUGGESTED = Math.floor(VOLUME_SUGGESTED / MIN_PER_VOL);

            return {
              NAME,
              BLADE_SUGGESTION,
              MIN_PER_VOL,
              TOTAL_TIME_CURRENT: ALL_AGN_DURATION,
              TOTAL_TIME_SUGGESTED: TIME_SUGGESTED,
              TOTAL_VOLUME_CURRENT: (ALL_AGN_DURATION * MIN_PER_VOL).toFixed(2),
              TOTAL_VOLUME_SUGGESTED: (TIME_SUGGESTED * MIN_PER_VOL).toFixed(2),
              DIFFERENCE_MINS: ALL_AGN_DURATION - TIME_SUGGESTED,
              SECTORS: (SECTORS || []).map((sector) => ({
                ...sector,
                TIME_SUGGESTED: Math.floor(
                  this.lam2vol(
                    sector.BLADE_SUGGESTION,
                    sector.AREA,
                    sector.TRANSMISSIVITY
                  ) / MIN_PER_VOL
                ),
              })),
            };
          })
          .filter((val) => val);

        schedule.alerts_management = this.getScheduleManagementStatus(schedule);

        return schedule;
      });
    },
    computedClass() {
      let className = "row align-items-center header";
      if (this.mobile) {
        className = "row align-items-center header-mobile";
        return className;
      }
      return className;
    },
    validFilter() {
      return !!this.filter.split(" ").join("");
    },
    whatToDelete() {
      return organizer(this.selected, "NAME");
    },
  },
  methods: {
    avgVolume,
    expiration,
    getManagementClassificationSchedule,
    hasManagementBlade(item) {
      return item.management_infos.filter(
        (manag) => manag && manag.BLADE_SUGGESTION >= 0
      ).length;
    },
    multiSectorValves(item) {
      return [
        ...new Set(
          (item.management_infos || [])
            .filter((manag) => manag && manag.SECTORS && manag.SECTORS.length > 1)
            .map((manag) => manag.NAME)
        ),
      ];
    },
    getScheduleManagementStatus(item) {
      if (!item.management_infos.length) {
        return;
      }

      const totalScheduleAlerts = [];
      const scheduleLevelsClassificationsByManagement =
        item.management_infos.map((manag) =>
          this.getManagementClassificationSchedule(manag.DIFFERENCE_MINS)
        );

      if (scheduleLevelsClassificationsByManagement.includes("low-water")) {
        totalScheduleAlerts.push({
          title:
            "Existe(m) válvula(s) com duração total abaixo do recomendado pelo manejo do sistema",
          class: "",
        });
      }

      if (scheduleLevelsClassificationsByManagement.includes("extra-water")) {
        totalScheduleAlerts.push({
          title:
            "Possui válvula(s) com duração total muito acima do indicado pelo manejo do sistema",
          class: "text-info",
        });
      }

      if (
        !scheduleLevelsClassificationsByManagement.filter(
          (classifications) => classifications !== "good-water"
        ).length
      ) {
        totalScheduleAlerts.push({
          title:
            "Todas as válvulas da agenda estão seguindo a sugestão do manejo do sistema",
          class: "text-success",
        });
      }

      return totalScheduleAlerts;
    },
    isBelowManagementIndication(item) {
      return item.management_infos.filter((manag) => {
        return (
          this.getManagementClassificationSchedule(manag.DIFFERENCE_MINS) ===
          "low-water"
        );
      }).length;
    },
    isAboveManagementIndication(item) {
      return item.management_infos.filter((manag) => {
        console.log({ manag });
        return (
          this.getManagementClassificationSchedule(manag.DIFFERENCE_MINS) ===
          "extra-water"
        );
      }).length;
    },
    isOnManagementIndication(item) {
      return (
        item.management_infos.filter((manag) => {
          return (
            this.getManagementClassificationSchedule(manag.DIFFERENCE_MINS) ===
            "good-water"
          );
        }).length === item.management_infos.length
      );
    },
    confirmPrint() {
      EventBus.confirmPrint();
      this.checked = true;
    },
    resetModal() {
      this.checked = true;
    },
    closeForm() {
      this.showForm = false;
      this.isDuplicateForm = false;
      this.selected = [];
    },
    duplicateAgn(item) {
      this.formType = "duplicate";
      this.showForm = true;
      // this.isDuplicateForm=true
      // this.selected.push(item)
    },
    onFilterBy(value) {
      // if (value == 100) this.clearSearch();
      this.isFiltering = value === 0 ? false : true;
      if (value.text) {
        this.filterOpt = value.text;
      }
      this.filterBy = value;
    },
    loadSensors() {
      sensors
        .list()
        .then((ret) => {
          this.sensors = ret.sensors;
          this.auxSensors = ret.aux;
        })
        .catch((err) => {
          this.sensors = [];
          console.log(err);
          alert("Ocorreu um erro ao carregar agendas.");
        });
      // .then((_) => (this.loading = false));
    },
    organizeAgns(list) {
      if (list.length) {
        return list.map((agn) => {
          if (agn.sublevels.length) {
            agn.sublevels = organizer(
              agn.sublevels.map((level) => {
                if (level.FERTI.length) {
                  level.FERTI = organizer(level.FERTI, "FERTILEVEL");
                }
                return level;
              }),
              "LEVEL"
            );
          }
          return agn;
        });
      } else return list;
    },
    loadFlows() {
      return schedules
        .getFlows()
        .then((ret) => {
          this.flows = ret;
        })
        .catch((err) => console.log(err));
    },
    loadSchedules() {
      this.loading = true;
      return schedules
        .list()
        .then((ret) => this.organizeAgns(ret))
        .then((ret) => {
          this.list = ret;
          this.fullList = this.list.map((e) => e);
          this.fullList = ret;
          this.selected = [];
          return;
        })
        .then((_) => {
          this.loadSensors();
          return;
        })
        .catch((err) => {
          alert("Erro ao carregar agendas.", "w");
          console.log(err);
          return;
        })
        .then((_) => (this.loading = false))
        .then((_) => {
          if (
            !this.list.length &&
            this.showErrorNotSearch === false &&
            !this.loading
          ) {
            this.showErrorNotFound = true;
          } else {
            this.showErrorNotFound = false;
            this.isActive();
          }
        });
    },
    isActive() {
      // this.list = [];
      this.isSearching = false;
      this.filter = "";
      if (this.filterBy == 0) {
        this.showErrorNotFound = false;
        this.list = this.fullList;
      } else if (this.filterBy == 100) {
        this.showErrorNotFound = false;
        this.list = this.fullList;
      } else if (this.filterBy.value) {
        this.list = this.fullList.filter((schedule) => {
          if (this.expiration(schedule.END_DATE, schedule.END_TIME)) {
            return true;
          }
          return false;
        });
        if (!this.list.length && !this.loading) {
          this.showErrorNotFound = true;
        } else {
          this.showErrorNotFound = false;
        }
      }
    },
    //troca de botões para adaptação ao serviço mobile
    isMobile(ref) {
      return isMobile(ref);
    },
    //checkboxes
    toggleAll() {
      this.allSelected = !this.allSelected;
      if (this.selected.length < this.list.length)
        this.selected = this.list.map(e);
      else if (this.selected.length == this.list.length) this.selected = [];
    },
    //modal de edição
    edit() {
      this.formType = "edit";
      this.showForm = true;
    },
    submit(data) {
      /* envio para api com a função importada do arquivo de api */
      schedules[this.formType === "duplicate" ? "add" : this.formType](data)
        .then((ret) => {
          alert(ret.log, ret.alert);
          if (ret.alert == "s") {
            setTimeout(this.loadSchedules, 1500);
            this.resetForm();
          }
          this.showForm = false;
        })
        .catch((err) => {
          console.log(err);
          alert(
            `Ocorreu um erro ao ${
              this.formType == "edit" ? "editar" : "cadastrar"
            } a agenda. Tente novamente.`
          );
          this.showForm = false;
          this.resetForm();
        });
    },
    //comum à edição e adição
    cancel(type) {
      this.resetForm();
    },
    //fazer função de resetar formulário, não esquecer de resetar o 'ends'
    resetForm() {
      this.formType = "";
      this.selected = [];
    },
    remove() {
      this.$refs.removeSchedule.show();
    },
    confirmRemove() {
      schedules
        .del(this.selected)
        .then((ret) => {
          alert(ret.log, ret.alert);
          if (ret.alert == "s") {
            this.loadSchedules();
            this.selected = [];
          }
        })
        .catch((err) => {
          console.log(err);
          alert("Ocorreu um erro. Tente novamente.");
        });
      this.$refs.removeSchedule.hide();
    },
    add() {
      this.formType = "add";
      this.showForm = true;
    },
    openLevels(item) {
      if (item.sublevels && item.sublevels.length) {
        this.details = item;
        this.showLevels = true;
      } else alert("Essa agenda não possui subníveis", "i");
    },
    showCond(item) {
      this.cond = item;
      let sensor = this.sensors.filter((e) => e.ID == item.FK_SENSOR)[0];
      let measure = this.auxSensors.filter(
        (e) => e.ID == item.FK_SENSOR && e.POS == item.POS_SENSOR
      )[0];
      this.cond.SENSOR_NAME = sensor.NAME || "";
      this.cond.SENSOR_MEASURE = measure.NAME_TYPE || "";
      this.cond.SENSOR_UNIT = measure.NAME_UNIT || "";
      this.$refs.condModal.show();
    },
    //referente aos dias de atuação tanto na view quanto nos modais de edição/adição
    formatDateTime(date, time) {
      if (date && time) {
        let datetime = `${date} ${time}`;
        return moment(datetime, "YYYY-MM-DD HH:mm:ss").format(
          "DD/MM/YYYY HH:mm"
        );
      }
      return;
    },
    formatDays(decDays) {
      let binDays = [0, 0, 0, 0, 0, 0, 0];
      for (let i = 0; i < 7; i++) {
        if (decDays > 0) {
          binDays[i] = decDays % 2;
          decDays = Math.floor(decDays / 2);
        }
      }
      return binDays
        .map(
          (e, i) =>
            `<strong>
              <span class='btn-day' style='color:${
                !!e ? "#7AB648" : "#DC3545"
              }; font-size:0.88em'>
                ${this.days[i].text}
              </span>
            </strong>`
        )
        .join(" ");
    },
    searchBy(filter) {
      this.selected = [];
      this.isSearching = !!filter.split(" ").join("");
      this.filter = filter.toUpperCase();
      if (this.isSearching && this.validFilter && this.list.length) {
        this.list = this.list.filter(
          (item) => item.NAME.indexOf(this.filter) > -1
        );
        if (this.list.length) {
          this.showErrorNotSearch = false;
        } else {
          this.showErrorNotSearch = true;
        }
      } else {
        this.list = this.fullList.map((e) => e);
      }
    },
    clearSearch() {
      this.selected = [];
      this.isSearching = false;
      this.showErrorNotSearch = false;
      this.$refs.INP.clearText();
      // this.list = this.fullList.map((e) => e);
      this.isActive();
    },
  },
};
</script>

<style scoped>
#details {
  padding-top: 110px;
  padding-bottom: 50px;
}
.form-time,
.form-levels {
  margin-top: 5px;
}
hr.to-form-level {
  display: none;
}
.volume-table {
  padding: 0 8px;
  max-height: 146px;
  overflow: hidden auto;
}
.header {
  flex-basis: 34px;
}
.schedule-card {
  padding-bottom: 30px !important;
}
.schedule-card .material-design-icon {
  vertical-align: -2px;
  margin: 0;
  color: #929292;
  font-size: 1.3em;
}
.header-title {
  display: flex;
  justify-content: space-between;
}
.header-card h5 {
  color: var(--text-gray-primary);
  font-family: "SourceSansPro_Semibold";
  text-overflow: ellipsis;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
}
.expiration {
  font-family: "SourceSansPro_Bold";
}
.header-card span {
  font-family: "SourceSansPro_Semibold";
  color: var(--text-gray-primary);
  font-size: 0.88em;
}

.margin-bottom {
  margin-bottom: 15px;
}
.schedule-list {
  max-height: 80vh;
  overflow-x: hidden;
}
.format-days {
  font-family: "SourceSansPro_Bold";
}
.selected-valve {
  width: 100%;
  background-color: #eeeeee;
  margin-bottom: 2px;
  color: #6d6d6d;
  padding-left: 5px;
  overflow: hidden;
}
.schedule-levels {
  margin-top: 3px;
  border: 1px solid rgba(0, 0, 0, 0.5);
  max-width: 550px;
  max-width: 100%;
  height: 430px;
  overflow-x: hidden;
}
.schedule-edit-form {
  padding-top: 5px;
  border-left: 1px solid #343a40;
  color: var(--text-gray-primary);
}

.scrollable {
  max-height: 260px;
  overflow-y: auto;
}
.schedule-edit-levels {
  padding-top: 5px;
  border-left: 1px solid #17a2b8;
  color: #17a2b8;
  max-height: 380px;
  overflow-y: auto;
}
.schedule-edit-levels .material-design-icon {
  font-size: 16px;
  vertical-align: -1px;
  color: var(--text-gray-primary);
}
.last-update {
  font-size: 0.7em !important;
  margin-left: 0 !important;
  margin-right: 6px !important;
  cursor: default !important;
  color: var(--text-gray-primary);
}
.item-card {
  min-height: 200px;
}
.footer {
  height: 35px;
  padding: 0 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.card-details {
  padding-top: 6px;
  min-height: 131px;
  overflow-y: auto;
  font-size: 0.86em;
  color: var(--text-gray-primary);
  text-overflow: ellipsis;
  line-height: 1.5em;
}
.card-details strong {
  font-family: "SourceSansPro_Bold";
  color: var(--text-gray-primary);
}
.card-details .btn-levels {
  margin-top: 4px;
}
.card-details a {
  padding: 3px 6px;
  border-radius: 5px;
  border: 1px solid #bebebe;
  font-weight: 500;
  font-size: 0.86em;
  color: #a1a1a1;
  transition: all 0.4s ease;
}
.card-details a:hover {
  background: #f7f7f7;
}
.btn-levels .material-design-icon {
  color: #17a2b8;
}

@media screen and (max-width: 991px) {
  .register-main {
    margin-bottom: 70px;
  }
  hr.to-form-level {
    display: block;
    width: 50%;
    height: 2px;
    margin-bottom: 8px;
  }
}
@media screen and (max-width: 767px) {
  .schedule-edit-form,
  .schedule-edit-levels {
    border: none;
  }
  .schedule-list {
    max-height: auto;
  }
  #details {
    padding-top: 2.5em;
    padding-bottom: 50px;
  }
  .header-card {
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .header {
    min-height: 90px;
  }
  .register-page .register-main {
    margin-top: 5.2em;
  }
}
@media screen and (max-width: 490px) {
  .schedule-levels {
    max-width: 95%;
    border-color: rgba(0, 0, 0, 0.5) transparent;
  }
}
</style>
